<section class="our-services-wrap" id="services">
  <div class="container">
    <h2 class="section-title">{{"services.title" | translate}}</h2>
    <p>{{"services.note" | translate}}</p>
    <ul>
      <li *ngFor="let item of benefits">
        <i class="fa fa-check"></i>
        {{ item }}
      </li>
    </ul>
    <div class="services-box">
      <div class="entity">
        <img src="assets/svgs/software.svg" alt="Software icon" loading="lazy"/>
        <h3>Software development</h3>
      </div>
      <div class="entity">
        <img src="assets/svgs/mobile.svg" alt="Mobile icon"loading="lazy" />
        <h3>Mobile development</h3>
      </div>
      <div class="entity">
        <img src="assets/svgs/consulting.svg" alt="Consulting icon" loading="lazy"/>
        <h3>IT Consulting</h3>
      </div>
      <div class="entity">
        <img src="assets/svgs/integration.svg" alt="Integration icon" loading="lazy"/>
        <h3>System integration</h3>
      </div>
    </div>
  </div>
</section>

